/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ImpactDirectionDto = {
	Front: 'Front',
	Rear: 'Rear',
	Right: 'Right',
	Left: 'Left',
	FrontRight: 'FrontRight',
	FrontLeft: 'FrontLeft',
	RearRight: 'RearRight',
	RearLeft: 'RearLeft',
	RightFront: 'RightFront',
	RightRear: 'RightRear',
	LeftFront: 'LeftFront',
	LeftRear: 'LeftRear',
} as const;
export type ImpactDirectionDto = (typeof ImpactDirectionDto)[keyof typeof ImpactDirectionDto];

export function instanceOfImpactDirectionDto(value: any): boolean {
	for (const key in ImpactDirectionDto) {
		if (Object.prototype.hasOwnProperty.call(ImpactDirectionDto, key)) {
			if (ImpactDirectionDto[key as keyof typeof ImpactDirectionDto] === value) {
				return true;
			}
		}
	}
	return false;
}

export function ImpactDirectionDtoFromJSON(json: any): ImpactDirectionDto {
	return ImpactDirectionDtoFromJSONTyped(json, false);
}

export function ImpactDirectionDtoFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ImpactDirectionDto {
	return json as ImpactDirectionDto;
}

export function ImpactDirectionDtoToJSON(value?: ImpactDirectionDto | null): any {
	return value as any;
}

export function ImpactDirectionDtoToJSONTyped(
	value: any,
	ignoreDiscriminator: boolean
): ImpactDirectionDto {
	return value as ImpactDirectionDto;
}
